import { render } from "./Sales_Record.vue?vue&type=template&id=6499f8ad"
import script from "./Sales_Record.vue?vue&type=script&lang=js"
export * from "./Sales_Record.vue?vue&type=script&lang=js"

import "./Sales_Record.vue?vue&type=style&index=0&id=6499f8ad&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__